export default __webpack_public_path__ + "static/media/logo_uia_2.10471329.png";